// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"f12243ad","405":"e94d438b","620":"0180b469","787":"340299c3","826":"8e52fceb","835":"dc18c63c","861":"c98795ef"}[chunkId] + ".chunk.js";
};